import React from 'react';
import { CHECKOUT_URL } from '../data/hvac';
const LINKS = ['Terms & Conditions', 'Privacy Policy', 'Contact'];
export function Footer() {
  return <footer className="bg-navy px-4 py-4" data-id="element-66" data-mp="3ghc3u5juj9pt">
      <div className="mx-auto max-w-3xl text-center" data-id="element-67" data-mp="32oe281gt8ldt">
        <p className="text-xs font-bold text-white/90" data-id="element-68" data-mp="32lrkj907gphv">
          © 2026 HVAC DIAGNOSTIC READY™ — All Rights Reserved.
        </p>
        <p className="mx-auto mt-1.5 max-w-2xl text-[11px] font-medium leading-snug text-white/60" data-id="element-69" data-mp="3ufa4k858v7mu">
          HVAC DIAGNOSTIC READY™ provides educational and professional troubleshooting
          resources for HVAC professionals. It does not replace required technical education,
          certification, licensing, equipment-specific manufacturer information, applicable
          safety procedures, local regulations or qualified professional judgment.
        </p>
        <ul className="mt-1.5 flex flex-wrap items-center justify-center gap-x-2 gap-y-1" data-id="element-70" data-mp="2a19sxkaopkw8">
          {LINKS.map((link, i) => <li key={link} className="flex items-center gap-2" data-id="element-71" data-mp="3l9adfilcf44f" data-mpi={i}>
              <a href={CHECKOUT_URL} className="text-[11px] font-semibold text-white/75 transition-colors duration-150 hover:text-diag" data-id="element-72" data-mp="3l9sgay2igglb">
                {link}
              </a>
              {i < LINKS.length - 1 && <span className="text-[11px] text-white/40" aria-hidden="true" data-id="element-73" data-mp="3q7lqs3aujwre">
                  •
                </span>}
            </li>)}
        </ul>
      </div>
    </footer>;
}